import { render } from "./SeriesDetails.vue?vue&type=template&id=58ceec34"
import script from "./SeriesDetails.vue?vue&type=script&lang=js"
export * from "./SeriesDetails.vue?vue&type=script&lang=js"

import "./SeriesDetails.vue?vue&type=style&index=0&id=58ceec34&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__